import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { deleteVoucherType } from '../../../../actions';

const VoucherTypeDeleteButton = ({
  dispatchDeleteVoucherType,
  voucherTypeId,
  disabled,
}) => {
  const [showModal, setShowModal] = useState(false);

  const onClickDelete = () => dispatchDeleteVoucherType({ voucherTypeId });

  const openModal = () => setShowModal(true);

  const closeModal = () => setShowModal(false);

  return (
    <>
      <ConfirmationModal
        show={showModal}
        onClickConfirm={onClickDelete}
        onClickCancel={closeModal}
      />
      <Button color="danger" onClick={openModal} disabled={disabled}>
        <i className="fa fa-trash-o" /> Eliminar
      </Button>
    </>
  );
};

VoucherTypeDeleteButton.propTypes = {
  dispatchDeleteVoucherType: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  voucherTypeId: PropTypes.number.isRequired,
};

VoucherTypeDeleteButton.defaultProps = {
  disabled: false,
};

const mapDispatchToProps = {
  dispatchDeleteVoucherType: deleteVoucherType,
};

export default connect(null, mapDispatchToProps)(VoucherTypeDeleteButton);
